import axios from "axios";

export default {
  state: {
    tours: [],
    currentTour: {},
    toursFetched: false,
  },

  mutations: {
    setCurrentTour(state, currentTour) {
      state.currentTour = currentTour;
    },

    setTours(state, tours) {
      state.tours = tours;
    },

    setToursFetched(state, toursFetched) {
      state.toursFetched = toursFetched;
    },
  },

  actions: {
    async getTours({ commit, state }) {
      try {
        if (state.toursFetched) return;

        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/paths`);

        let tours = [];
        res.data.forEach((el) => {
          if (el?.multi_day) tours.push({ ...el, tour: true });
          else tours.push({ ...el, tour: false });
        });
        tours.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        // console.log(tours);
        // tours = res.data;

        commit("setTours", tours);
        commit("setToursFetched", true);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
